import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { generateChecksum } from '../middleware/generateChecksum';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL + '/v2/api/' }),
  endpoints: (builder) => ({
    getAuthData: builder.query({
      query: () => 'get_auth/58912004',
      transformResponse: (response) => response
    }),
    getRedirectionUrl: builder.query({
      query: (data) => `web_landing_page?auth_token=${data.auth_token}`,
      transformResponse: (response) => response
    }),
    getPartnersDetails: builder.query({
      query: (data) => `get_partners_details?secret=${data.secret}&utm_source=${data.utm}`,
      transformResponse: (response) => response
    }),
    postOtp: builder.mutation({
      query: (data) => {
        const body = new URLSearchParams({
          phone_email: data.phone,
          otp: data.otp,
          mode: 'login',
          phone: data.phone,
          checksum: data.checksum,
          device_id: data.device_id,
          accept_status: data.accept_status,
          utm_source:data.utm_source,
          partner_unique_id: data.partner_unique_id,
          consents: data.consents,
        }).toString();

        return {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
            secret: data.secret
          },
          body,
        };
      },
    }),
    generateOtp: builder.mutation({
      query: (data) => {
        const body = {
          phone: data.phone,
          mode: 'generate_otp'
        }
        const checksum = generateChecksum(body)
    
        return {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
            secret: data.secret
          },
          body: new URLSearchParams({...body, checksum}).toString(),
        };
      },
    }),    
  }),
});

export const { useGetAuthDataQuery, useLazyGetRedirectionUrlQuery, useLazyGetPartnersDetailsQuery, usePostOtpMutation, useGenerateOtpMutation } = authApi;
